export default __webpack_public_path__ + "static/media/weight-gray.74f141c1.svg";